import { PostSection } from "@/components/blog/PostSection";

export function BusquedaConversacionalSection() {
  return (
    <PostSection id="busqueda-conversacional" title="Búsqueda conversacional, por voz y multimodal">
      <p>
        El uso de búsqueda por voz, asistentes como Siri, Alexa y Google Assistant, y de búsquedas 
        conversacionales está en plena explosión. Una parte significativa de las consultas ya viene 
        en formato de pregunta natural o directamente por voz.
      </p>

      <h3 id="voz-asistentes" className="text-xl font-bold text-white mt-8 mb-4">
        Voz y asistentes inteligentes
      </h3>
      <p>
        Las búsquedas por voz tienden a ser más largas, conversacionales y con intención local. 
        Para adaptarte:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Escribe en tono conversacional:</strong> como habla la gente, no como un texto académico</li>
        <li><strong>Incluye FAQs:</strong> preguntas y respuestas que reflejen consultas naturales</li>
        <li><strong>Optimiza para long-tail:</strong> frases como «¿dónde puedo encontrar un buen...?»</li>
        <li><strong>Schema FAQ:</strong> datos estructurados que los asistentes puedan leer directamente</li>
      </ul>

      <h3 id="busqueda-visual" className="text-xl font-bold text-white mt-8 mb-4">
        Búsqueda visual y multimedia
      </h3>
      <p>
        La búsqueda ya no es solo texto. Google Lens, las búsquedas visuales y los resultados multimedia 
        ganan terreno cada día. Los motores de IA integran mejor estos formatos y pueden extraer 
        información de imágenes, vídeos y audio.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li>Optimiza imágenes con alt text descriptivo y nombres de archivo relevantes</li>
        <li>Incluye transcripciones en contenido de vídeo y audio</li>
        <li>Usa meta datos multimedia completos</li>
        <li>Crea infografías y gráficos que transmitan datos clave visualmente</li>
      </ul>
    </PostSection>
  );
}
